export const isEnpsMetricDisplayName = (name: string): boolean =>
  name.trim().toLowerCase() === 'enps';

export const isEnpsCategoryId = (categoryId: string): boolean =>
  categoryId.trim().toLowerCase() === 'enps';

export const formatEnpsScoreForDisplay = (value: number): string => {
  if (!Number.isFinite(value)) return '0';
  const rounded = Math.round(value * 100) / 100;
  return String(rounded);
};
